import { create } from "../../../common/utils/zustand_state_manager";
import { IControleDocumentosService } from "../../../features/controleDocumentos/data/services/controle_documentos_service";
import { ControleDocumentosService } from "../../../features/controleDocumentos/data/services/controle_documentos_service_impl";

/**
 * useControleDocumentosServices
 */

type State = {
  controleDocumentosService: IControleDocumentosService,
};

export const useControleDocumentosServices = create<State>((set, get) => ({
  controleDocumentosService: new ControleDocumentosService(),
}));